(function(angular) {
	angular.module('bizPartEngage').directive('compareTo', compareToDirective);
	angular.module('bizPartEngage').directive('bizGo', bizGoDirective);
	angular.module('bizPartEngage').directive('bizHideComponent', bizHideComponentDirective);
	angular.module('bizPartEngage').service('bizHideComponentService', bizHideComponentService);
	angular.module('bizPartEngage').service('bizPhraseLogService', bizPhraseLogService);

	bizHideComponentDirective.$inject = ["bizHideComponentService"];
	bizHideComponentService.$inject = ["$q"];

	bizPhraseFilter.$inject = ["$translate", "$rootScope"]
	bizPhraseDirective.$inject = ["$rootScope", "$translate", "$filter", "$compile", "$timeout", "bizPhraseLogService"];

	bizPhraseLogService.$inject = ["bizCoreService", "$q", "$http"];

	function bizPhraseLogService(bizCoreService, $q, $http) {
	    this.Phrases = [];

	    this.IsEnabled = function () {
	        if (this.Promise)
	            return this.Promise;

	        var defer = $q.defer();
	        this.Promise = defer.promise;

	        bizCoreService.Admin.GetGenericSetting('CULTURE', 'bizPhraseLoggingEnabled', 0).then(function (response) {
	            defer.resolve(response.data);
	        });

	        return this.Promise;
	    };

	    this.LogPhrase = function (key, value, culture) {
	        this.IsEnabled().then(function (data) {
	            if (!data || data.Value.toLowerCase() == 'false')
	                return;

	            $http.get(siteRootPath + "api/culture/LogBizPhrase", { params: { key: key, value: value, culture: culture } });
	        })
	    }
	}

	function bizHideComponentDirective(bizHideComponentService) {
		var directive = {
			restrict: "A",
			link: linkFunction
		}

		function linkFunction(scope, elem, attrs) {
			bizHideComponentService.Hiding().then(function (components) {
				if (!components[attrs.bizHideComponent])
					return;

				elem.remove();
			});
		}

		return directive;
	}

	function bizHideComponentService($q) {
		var hiddenComponents = {};
		var initializing = $q.defer();

		return {
			Hide: Hide,
			Hiding: Hiding
		};

		function Hide(components) {
			if (!components) {
				components = getLocalStorage("bizHideComponents");

				if (!components)
					return;
			}
			
			setLocalStorage("bizHideComponents", components);

			components = components.split(",");
			for (var i = 0; i < components.length; i++) {
				hiddenComponents[components[i]] = true;
			}

			initializing.resolve(hiddenComponents);
		}

		function Hiding() {
			return initializing.promise;
		}
	}

    function compareToDirective() {
        var directive = {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: compareToLink
        }

        function compareToLink(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }

        return directive;
    }

    function bizPhraseDirective($rootScope, $translate, $filter, $compile, $timeout, bizPhraseLogService) {
    	var directive = {
    		restrict: "A",
			link: linkFunction
    	};

    	function linkFunction(scope, element, attrs) {
    		$rootScope.CultureInitialized.then(function () {
    		    $translate(attrs.bizPhrase).then(function (translation) {
    		        element.text(translation);

    		        if (!bizPhraseLogService.Phrases.GetItemByValue('Key', attrs.bizPhrase))
    		            bizPhraseLogService.LogPhrase(attrs.bizPhrase, translation.toString(), $translate.use());
    		        bizPhraseLogService.Phrases.push({ Key: attrs.bizPhrase });

    		    }, function () {
    		        if (!bizPhraseLogService.Phrases.GetItemByValue('Key', attrs.bizPhrase)) {
    		            bizPhraseLogService.LogPhrase(attrs.bizPhrase, "", $translate.use());
    		            bizPhraseLogService.Phrases.push({ Key: attrs.bizPhrase });
    		        }
    				console.warn(String.format("bizPhrase | Phrase not found for current culture ({0}): {1}", $translate.use(), attrs.bizPhrase));
    			});
    		});
    	}

    	return directive;
    }

    function bizPhraseFilter($translate, $rootScope) {
    	var phrases = {};
    	var promises = {};
    	return function (key) {
    		if (phrases[key])
    			return phrases[key];

    		if (promises[key])
    			return;

    		promises[key] = true;

    		$rootScope.CultureInitialized.then(function () {
    			$translate(key).then(function (translation) {
    				phrases[key] = translation.toString();
    			}, function (key) {
    				phrases[key] = undefined;
    				console.warn(String.format("bizPhrase | Phrase not found for current culture ({0}): {1}", $translate.use(), key));
    			});
    		});
    	}
    }

	function bizGoDirective() {
		var directive = {
			restrict: "A",
			link: bizGoLink
		};

		function bizGoLink(scope, element, attrs) {
			var path = "";

			attrs.$observe('bizGo', function (val) {
				path = val;
			});

			element.bind('click', function () {
				if (path && path != "") {
					window.location.href = path;
				}
			});
		}

		return directive;
	}
})(window.angular);
